/* eslint-disable */
import moment from 'moment';
import qs from 'qs';
import rison from 'rison';
import { browserHistory } from 'react-router';
import cookie from 'js-cookie';
import changeCase from 'change-object-case';

import { API_HOST } from '../config';

export function getToken(state) {
  let token = null;
  if (state) {
    token = state.token;
  }
  if (!token) {
    token = cookie.get('token', { path: '/' });
  }
  console.log('token', token);
  if (!token) {
    return null;
  }
  return token;
}

export function setToken(token) {
  cookie.set('token', token, { expires: 1000, path: '/', domain: 'www.escapespy.com' });
  cookie.set('token', token, { expires: 1000, path: '/', domain: 'dev.escapespy.com' });
  cookie.set('token', token, { expires: 1000, path: '/', domain: 'localhost' });
}

export function clearToken() {
  cookie.remove('token');
  cookie.remove('token', { domain: 'www.escapespy.com' });
  cookie.remove('token', { domain: 'dev.escapespy.com' });
  cookie.remove('token', { domain: 'localhost' });
}

export function isLoggedIn() {
  return !!getToken();
}

export function logout() {
  clearToken()
  window.location.href = '/';
}

export function login(username, password) {
  return fetch(url('/api-auth-token/'), {
    method: 'POST',
    body: JSON.stringify({
      username: username,
      password: password,
    }),
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
    },
  })
    .then(resp => jsonAndStatus(resp))
    .then(({ data, status }) => {
      if (ok(status)) {
        setToken(data.token);
        window.location.href = '/';
      }
      return { status: status, data: data };
    });
}

export function tokenLogin(token) {
  return fetch(url('/api/use-login-token/'), {
    method: 'POST',
    body: JSON.stringify({
      token: token,
    }),
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
    },
  })
    .then(resp => jsonAndStatus(resp))
    .then(({ data, status }) => {
      if (ok(status)) {
        setToken(data.token);
      }
      return { status: status, data: data };
    });
}

export function url(path) {
  return API_HOST + path;
}

export function authHeader(state) {
  let token = getToken(state);
  if (!token) return {};
  return {
    'Authorization': `Token ${token}`,
  }
}

export function authContentTypeHeader(contentType, state) {
  let token = getToken(state);
  return {
    'Authorization': `Token ${token}`,
    'Content-Type': contentType,
  }
}

export function authJsonHeader(state) {
  let token = getToken(state);
  return {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
    'Authorization': `Token ${token}`,
  }
}

export function jsonHeader() {
  return {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  }
}

export function ss(obj, field) {
  return (e) => {
    let newState = {};
    newState[field] = e.target.value;
    obj.setState(newState);
  }
}

export function ssfv(obj) {
  return (field, value) => {
    let newState = {};
    newState[field] = value;
    obj.setState(newState);
  }
}

export function json(resp) {
  return resp.json()
    .then(data => changeCase.camelKeys(data, {recursive: true, arrayRecursive: true}));
}

export function jsonAndStatus(resp) {
  return resp.json()
    .then(json => { return {
      status: resp.status,
      data: changeCase.camelKeys(json, {recursive: true, arrayRecursive: true})
    }});
}

export function fetchMe() {
   return fetch(url('/api/me'), { headers: authHeader() })
     .then(resp => resp.json())
}

export function adminBecome(email) {
   return fetch(url('/api/admin/become/?email=' + email), { headers: authHeader() })
     .then(resp => resp.json())
}

export function newOrder(e) {
  if (e) {
    e.preventDefault();
  }
  fetch(url('/api/orders'), {
    method: 'POST',
    headers: authJsonHeader(),
  })
    .then(resp => json(resp))
    .then(data => {
      let url = `/orders/place/${data.id}`;
      // TODO: fix this hack to for re-mount when on place order page
      if (window.location.pathname.startsWith('/orders/place')) {
        window.location.href = url;
      } else {
        browserHistory.push(url);
      }
    });
}

export function usd(val, int=false) {
  if (!val) {
    return;
  }

  let withCommas = numberWithCommas(val);
  let m = withCommas.match(/^(.*\.\d\d).*/);
  if (m) {
    withCommas = m[1];
  }
  if (withCommas.match(/.*\.\d$/)) {
    withCommas += '0';
  }
  return '$' + withCommas;
}

export function numberWithCommas(x) {
  if (x == undefined) {
    return;
  }
  let m = x.toString().match(/^(.*?\...).+$/);
  if (m) {
    x = m[1];
  }
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export function obscurePrice(price) {
  if (!price) {
    return;
  }
  
  let lower = Math.floor(price * .98);
  let upper = Math.ceil(Math.floor(price) * 1.1);
  if (lower == 0) {
    lower++;
    upper++;
  }
  if (lower == upper) {
    upper++;
  }
  return '$' + lower + '-' + upper;
}

export function vs(errors, field) {
  if (!errors || !errors[field]) {
    return null;
  } else {
    return 'error';
  }
}

export function ok(status) {
  return status >= 200 && status < 300;
}

export function cleanPhone(phone) {
  let val = phone;
  if (phone.match(/\+?1/)) {
    phone = phone.replace(/^\+?1/, '');
  }
  let numbers = phone.replace(/[^0-9]/g, '');
  if (numbers.length >= 10) {
    let m = numbers.match(/^([0-9]{3})([0-9]{3})([0-9]+)/);
    val = `(${m[1]}) ${m[2]}-${m[3]}`;
  }
  return val;
}

export function e164Phone(phone) {
  if (!phone) {
    return;
  }
  let numbers = phone.replace(/[^0-9]/g, '');
  if (!numbers.startsWith('1')) {
    numbers = '1' + numbers;
  }
  return numbers;
}

export function errorsFrom(state, key) {
  if (!state.errors) return null;
  if (!state.errors[key]) return null;
  return state.errors[key];
}

export function navTo(path, shouldScroll=true) {
  browserHistory.push(path);
  if (shouldScroll) {
    scroll(0, 0);
  }
}

export function upperFirst(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

export function mapDispatch(dispatch, fns) {
  let map = {};
  for (let name of Object.keys(fns)) {
    let fn = fns[name];
    map[name] = (...args) => dispatch(fn(...args));
  }
  return map;
}

// Make sure this is synced with util.py
export function weekCohort(date) {
  if (!date) {
    date = moment();
  }
  let referenceDay = moment('2000-01-01', 'YYYY-MM-DD');
  let weeksSince = Math.floor(date.diff(referenceDay, 'days') / 7);
  return weeksSince % 2 == 1 ? 'odd' : 'even';
}

export function snakeKeys(params) {
  let snakeParams = {};
  for (let key of Object.keys(params)) {
    let snakeKey = '';
    if (key.indexOf('_') == -1) {
      snakeKey = changeCase.snakeCase(key);
    } else {
      snakeKey = key;
    }
    snakeParams[snakeKey] = params[key];
  }
  return snakeParams;
}

export function distance(lat1, lon1, lat2, lon2, unit) {
  let radlat1 = Math.PI * lat1/180
  let radlat2 = Math.PI * lat2/180
  let radlon1 = Math.PI * lon1/180
  let radlon2 = Math.PI * lon2/180
  let theta = lon1-lon2
  let radtheta = Math.PI * theta/180
  let dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
  dist = Math.acos(dist)
    dist = dist * 180/Math.PI
  dist = dist * 60 * 1.1515
  if (unit=="K") { dist = dist * 1.609344 }
  if (unit=="N") { dist = dist * 0.8684 }
  return dist
}

export function prettyHour(datetime) {
  let m = datetime.match(/\d+-\d+-\d+T(\d+):(\d+):\d+/);
  let hour = parseInt(m[1]);
  let minute = m[2];
  let ampm;
  if (hour < 12) {
    ampm = 'am';
  } else {
    ampm = 'pm';
  }
  if (hour == 0) {
    hour = 12;
  } else if (hour >= 13) {
    hour = hour % 12;
  }
  return hour + ':' + minute + ampm;
}

export function prettyDate(datetime) {
  let m = datetime.match(/\d+-(\d+)-(\d+)T\d+:\d+:\d+/);
  let month = m[1];
  let day = m[2];
  return month + '/' + day;
}

export function money(amount, currency) {
  if (amount.amount && amount.currency && !currency) {
    return money(amount.amount, amount.currency);
  }

  if (!amount && !currency) {
    return '';
  }

  if (amount.amount != undefined && amount.currency != undefined && !currency) {
    return money(amount.amount, amount.currency);
  }

  if (amount) {
    amount = moneyWithCommas(amount);
  }
  if (currency == 'USD' || currency == 'CAD') {
    return '$' + amount;
  } else {
    return amount + ' ' + currency;
  }
}

export function moneyWithCommas(val, int=false) {
  if (!val) {
    return;
  }

  let withCommas = numberWithCommas(val);
  let m = withCommas.match(/^(.*\.\d\d).*/);
  if (m) {
    withCommas = m[1];
  }
  if (withCommas.match(/.*\.\d$/)) {
    withCommas += '0';
  }
  return withCommas;
}

export function getParams() {
  let search;
  try {
    search = window.location.search;
  } catch (e) {
    return {};
  }
  if (!search) {
    return {};
  }
  let queryString = window.location.search.replace(/^\?/, '');
  return changeCase.camelKeys(qs.parse(queryString));
}

export function addUrlParam(addParams, nav=true) {
  try { window } catch(e) { return }
  let params = Object.assign({}, getParams(), addParams);
  let newPath = window.location.pathname + '?' + qs.stringify(params);
  if (nav) navTo(newPath);
}

export function removeUrlParam(removeParams, nav=true) {
  try { window } catch(e) { return }

  let params = Object.assign({}, getParams());
  for (let p of removeParams) {
    if (p in params) {
      delete params[p];
    }
  }

  let newPath = window.location.pathname + '?' + qs.stringify(params);
  console.log('setting new path', newPath);
  if (nav) navTo(newPath);
}

export function parseTimeString(s) {
  let m = (''+s).match(/(\d+)(:\d+)?/);
  if (m) {
    let r = {};
    r.time = m[1];
    if (m[2]) {
      r.seconds = m[2].replace(/:/, '');
    }
    return r;
  }
  return null;
}


export function tokenMatch(hayStack, needle) {
  let nParts = needle.split(' ');
  let hParts = hayStack.split(' ');
  console.log('token match', hParts, nParts);

  let matchCount = 0;
  for (let n of nParts) {
    let matched = false;
    for (let h of hParts) {
      if (h.toLowerCase().indexOf(n.toLowerCase()) != -1) {
        console.log('matched!', h, n);
        matched = true;
      }
    }
    if (matched) {
      matchCount++;
    }
  }
  console.log('ok?', matchCount, nParts.length);
  return matchCount >= nParts.length;
}

export function hour24(h) {
  if (h == 0) return '12am';
  if (h < 12) return h + 'am';
  if (h == 12) return '12pm';
  return (h % 12) + 'pm';
}

export function urlEncodeQueryFilters(filters) {
  let encoded = rison.encode_array(filters);
  console.log('rison encode_array', encoded);

  let shouldTrans = [
    ['&', '%26'],
    ['=', '%3D'],
  ];

  let parts = encoded.split('%');
  let transParts = [];
  for (let part of parts) {
    for (let pair of shouldTrans) {
      part = part.replace(pair[0], pair[1]);
    }
    transParts.push(part);
  }

  let percentEncoded = '%25';
  let encodedTrans = transParts.join(percentEncoded);
  return encodedTrans;
}

export function urlDecodeQueryFilters(filters) {
  try {
    return rison.decode_array(filters);
  } catch (e) {
    return [];
  }
}



/** WEBPACK FOOTER **
 ** ./src/utils/util.js
 **/